import { React } from "react";
import { AppBar, Toolbar, Typography, Button, Box } from "@mui/material";
import { Link } from "react-router-dom";
import ThemeSwitcher from "../../components/common/ThemeSwitcher";
import { useTranslation } from "react-i18next";

function LandingNav() {
	const { t } = useTranslation();

	return (
		<>
			<AppBar position="static" color="default" enableColorOnDark>
				<Toolbar>
					<Typography variant="h6" sx={{ flexGrow: 1 }}>
						FinApp
					</Typography>
					<Box>
						<Button component={Link} to="/login" color="inherit">
							{t("login")}
						</Button>
						<Button component={Link} to="/register" color="inherit">
							{t("register")}
						</Button>
						<ThemeSwitcher />
					</Box>
				</Toolbar>
			</AppBar>
		</>
	);
}

export default LandingNav;
